import { v4 as uuid } from 'uuid';
import { minnieMouse } from '../patients';
import { mickAbae } from '../providers';
import { editableEncounter } from './editableEncounter';

export const encounterIdWithBasicInfo = uuid();

export const encounterWithBasicInfo = {
  patient: minnieMouse,
  encounterId: encounterIdWithBasicInfo,
  provider: mickAbae,
  assessments: [{ description: 'assessments description', code: 'assessments code' }],
  basicInformation: {
    encounterDateOfService: '2024-01-15',
    type: 'Office Visit',
    status: 'UNLOCKED',
    selfPay: false,
  },
  encounterNotes: {
    generalNotes: 'encounter notes',
  },
  patientInstructions: {
    generalNotes: 'patient instructions',
  },
  editableEncounter,
};
